export default __webpack_public_path__ + "static/media/video2.714f7564.mp4";